import { SortOrder } from "@/types/gql/graphql";
import { HeaderItem } from "components/data-table/types/table.types";
import { UserReport } from "types/user-report.type";

export const defaultUserReportCells: HeaderItem<keyof UserReport>[] = [
  { title: "ID" },
  {
    title: "Note",
    orderBy: "note",
    sortable: true,
    sortDirection: SortOrder.Asc,
  },
  {
    title: "File",
    className: "w-20 text-center",
  },
  {
    title: "Done",
    className: "w-20 text-center",
    sortable: true,
    orderBy: "isDone",
    sortDirection: SortOrder.Desc,
  },
];
